import { GetStaticProps } from 'next';
import { getDataHooksProps } from 'next-data-hooks';
import React from 'react';
import CookieConsentWrapper from '@components/Shared/CookieConsentWrapper/CookieConsentWrapper';
import Blog from '@components/Blog/Blog';

export const getStaticProps: GetStaticProps = async (context) => {
  const dataHooksProps = await getDataHooksProps({
    context,
    dataHooks: Blog.dataHooks,
  });

  return {
    props: { ...dataHooksProps },
  };
};

const BlogPage: React.FC = () => {
  return (
    <CookieConsentWrapper>
      <Blog />
    </CookieConsentWrapper>
  );
};

export default BlogPage;
